import { GetClientConstraintsResponse } from 'api/typegen/client/application/constraints/get';
import { QueryStatus, useQuery } from '@tanstack/react-query';
import getClientConstraintsApiCall from 'api/calls/getClientConstraintsApiCall';
import useAuth from './useAuth';

interface UseLoanConstraintsQuery {
  status: QueryStatus;
  loanClientConstraints?: GetClientConstraintsResponse;
}

const useLoanClientConstraintsQuery = (): UseLoanConstraintsQuery => {
  const { token } = useAuth();
  const query = useQuery(
    ['getClientConstraintsApiCall', token],
    getClientConstraintsApiCall,
    {
      enabled: !!token,
      staleTime: Infinity,
    },
  );

  return {
    status: query.status,
    loanClientConstraints: query.data,
  };
};

export default useLoanClientConstraintsQuery;
